const comments = [
  {
    name: '电影爱好者小陈',
    time: '2小时前',
    rating: 5,
    text: '天天影院真的太香了！最新电影大全更新超快，周末一口气刷了五部科幻片高清播放，画质清晰流畅，关键还完全免费，已经推荐给全公司同事了。',
  },
  {
    name: '周末追剧人',
    time: '5小时前',
    rating: 5,
    text: '找了好久靠谱的免费电影网站，终于遇到天天影院。动作片在线资源比我想象的丰富太多，极速播放确实不卡，下班回家躺在沙发上看大片就是爽。',
  },
  {
    name: '经典影片收藏家',
    time: '1天前',
    rating: 5,
    text: '惊喜发现天天影院有经典电影全集！很多老片子在其他平台都下架了，这里居然还能高清在线看。页面干净没有弹窗广告，观影体验满分。',
  },
  {
    name: '悬疑片重度患者',
    time: '1天前',
    rating: 4,
    text: '喜剧片免费看和科幻片高清播放这两块的片源都很新，每天都有更新提醒。希望后续能增加更多海外小众独立电影，整体非常满意。',
  },
  {
    name: '带娃观影妈妈',
    time: '3天前',
    rating: 5,
    text: '周末带孩子看动画电影不用到处找资源了，天天影院动画分类齐全，高清画质对眼睛友好。最重要的是没有乱七八糟的广告弹窗，家长很放心。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          影迷热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          听听天天影院的影迷们怎么说
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className={`bg-background-100 border border-background-200/60 rounded-lg p-5 ${
                idx === 0 ? 'md:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-500/15 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-500 font-heading font-bold text-sm">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">
                    {comment.name}
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="flex gap-0.5">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <span key={i} className="w-3 h-3 flex items-center justify-center">
                          <i
                            className={`text-xs ${
                              i < comment.rating
                                ? 'ri-star-fill text-primary-500'
                                : 'ri-star-line text-foreground-300'
                            }`}
                          ></i>
                        </span>
                      ))}
                    </div>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}